<template>
  <div class="travel-comment" :data-rating="ratingAvg">
    <div class="media">
      <div class="media-body">
        <p class="lead-text">{{ date | toDateString }} – {{ name }}</p>
        <div class="visible-xs" v-if="ratingAvg">
          <div class="row">
            <div class="col-xs-12">
              <div class="star-rating">
                <div class="star-rating-icons">
                  <i v-for="index in 5" :key="index" class="icon icon-star"></i>
                </div>
                <div class="star-rating-icons-overlay">
                  <i v-for="index in parseInt(ratingAvg/2)" :key="index" class="icon icon-star"></i>
                  <i v-if="(ratingAvg/2) % 1 >= 0.3" class="icon icon-star-half"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="text">
          <strong>{{ title }}</strong>
          <p>{{ text }}</p>
          <blockquote v-if="comment">
            <strong class="colored">Antwort von company name</strong><br/>
            {{ comment }}
          </blockquote>
        </div>
      </div>

      <div class="media-right hidden-xs" v-if="ratingAvg">
        <div class="row">
          <div class="col-xs-12">
            <div class="star-rating">
              <div class="star-rating-icons">
                <i v-for="index in 5" :key="index" class="icon icon-star"></i>
              </div>
              <div class="star-rating-icons-overlay">
                <i v-for="index in parseInt(ratingAvg/2)" :key="index" class="icon icon-star"></i>
                <i v-if="(ratingAvg/2) % 1 >= 0.3" class="icon icon-star-half"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="travel-rating-summary" v-if="detailRatings">
      <a class="travel-rating-detail-toggle collapsed" role="button" data-toggle="collapse"
         aria-expanded="false" aria-controls="bewertungen-collapse" :href="'#travel-rating-collapse-'+index">Details
        <span class="ein">&nbsp;einblenden</span><span class="aus">&nbsp;ausblenden</span>
      </a>
      <div :id="'travel-rating-collapse-'+index" class="collapse travel-rating-groups">
        <div class="row">
          <div v-for="d in detailRatings" class="col-xs-12 col-sm-12 col-md-6">
            <div class="travel-group-rating row">
              <div class="col-xs-12 col-sm-5">
                {{ d.bezeichnung }}
              </div>
              <div class="col-xs-12 col-sm-7">
                <div class="star-rating">
                  <div class="star-rating-icons">
                    <i v-for="index in 5" :key="index" class="icon icon-star"></i>
                  </div>
                  <div class="star-rating-icons-overlay">
                    <i v-for="index in parseInt(parseFloat(d.bewertung)/2)" :key="index" class="icon icon-star"></i>
                    <i v-if="(parseFloat(d.bewertung)/2) % 1 >= 0.3" class="icon icon-star-half"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<style></style>
<script>
export default {
  name: "travel-review-item",
  props: {
    name: String,
    title: String,
    text: String,
    index: Number,
    ratingAvg: Number,
    comment: String,
    date: String,
    detailRatings: Array
  },
  data: function () {
    return {

    }
  },
  filters: {
    toDateString: function (value) {
      return moment(value).format('DD.MM.YYYY')
    }
  },
  methods: {

  },
  mounted() {

  },
  computed: {

  }
}
</script>
